import { Group, Text, Button, Paper } from '@mantine/core'
import { IconEye, IconX } from '@tabler/icons-react'
import { useAuth } from '../contexts/AuthContext'

function ImpersonationBanner() {
  const { isImpersonating, user, realAdminUser, exitImpersonation } = useAuth()

  if (!isImpersonating) return null

  return (
    <Paper
      p="sm"
      style={{
        backgroundColor: '#FFF3CD',
        borderBottom: '2px solid #FFC107',
        position: 'sticky',
        top: 0,
        zIndex: 1000
      }}
    >
      <Group justify="space-between">
        <Group gap="xs">
          <IconEye size={20} color="#856404" />
          <Text size="sm" fw={600} c="#856404">
            🔍 Viewing as: {user?.name || user?.email}
          </Text>
          <Text size="xs" c="dimmed">
            (Admin: {realAdminUser?.email})
          </Text>
        </Group>

        <Button
          size="xs"
          variant="light"
          color="dark"
          leftSection={<IconX size={14} />}
          onClick={exitImpersonation}
        >
          Exit Impersonation
        </Button>
      </Group>
    </Paper>
  )
}

export default ImpersonationBanner
